<template>
  <div>
    <el-dialog v-bind="$attrs" width="700px" custom-class="recharge" :before-close="handleSmsClose" append-to-body>
      <template slot="title">
        <span class="dialog-title">{{ title }}</span>
      </template>
      <div>
        <div v-loading="loading" class="recharge">
          <div v-for="(item,index) in rechargeItem" :key="index" :class="currentId-1 === index ? 'recharge-item choose' : 'recharge-item'">
            <div>
              <el-radio v-model="currentId" :class="currentId-1 === index ? 'pick-label':''" :label="item.id" @change="radioChange">{{ item.price }}元</el-radio>
            </div>
            <div>{{ item.content }}：<span class="number">{{ item.serviceAmount }}个</span>
              <font>· {{ item.remark }}</font>
            </div>

          </div>
        </div>
      </div>
      <!-- 支付方式 -->
      <div class="pay">
        <el-tabs v-model="payMethod" type="border-card">
          <el-tab-pane label="微信支付" name="weixin">
            <div class="pay-method">
              <div class="weixin">
                <div class="img">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAABfVBMVEUAAAAAAAAA/wAA/wAAqgAAzAAA1QAAvwAAqgAAxgAAuQAAvwAAtgAAuwAAvwAAtgALtQAKwgoKxAoJvQkJvwkItwgHugcHvAcMvAYGuAYGvgYMvwYGuwYLvAYLvgULugUKuwUKvAUJvgUJvAQJvAkIvAgIvggIuwgIvAgIuggIvAgHvAcHuwcHvAcKvQcKuwYJvAkJugYIvQgKuwgIvAgJuwcJuwcJvQcJvAYJvQYIuwYIuwYKuwgIvAYKvAgJuwgJvAgJvAcJvAcJvAcJuwcJvAcJuwcJvAcIuwcIuwcIvQcIvAcIvAcKugYJuwgJuwgJuwYJvAcJuwcIvAcIuwcKuwcKuwcKvAcJvAcJuwcJuwcJuwYJuwgJvAYJuwgJvAYJuwcJvAcJuwcIuwcIuwcJuwcJvAcJugcJugcJuwcJuwcJuwcJuwcJugYIuwYIuwYIvAcIuwcIuwYIvAcIuwcJuwcJugcJuwcJuwcJvAcJuwcJugcJuwcJvAcJuwddt9ceAAAAfnRSTlMAAQECAwUGCAkJCwwODxAVGBkaGxwgJSYqKyssLS4vMDE1Nzk5PT9AQUNERUdISU9XWV1iY210dHZ3e3x8fYaHiImMjY6RkpWZmpqbnKCiqKmrs7a4ubu7vcDEx8jJy87R0dLT19vc3+Pk6Onq7vDy8vP09vf4+fn6+vv9/v5X2EvHAAABG0lEQVQYGY3BBVfCYAAF0CdiYmCL3YCIhYFidxd2YwuCLYqf77e7jZ2dAfMc78V/WWwtzbZcGHBMBwQl4mbJnY4E3WfUue0zQ2P1M8lROVR1IaYI26GofKCBlypIcq6ZSvgdkI0zRXS1GugaAYqiTBKZLAEqtvlZCi9lEUHV3UAeYJn4IDmEfco87iBlgd4MAD33lO0iSNkhrDv82euApOaAcUF8UdEEU2ctJAVzMaqieKJiAwqTJ0TNMy6piJVB0nhMnQssMm4GKFz+pt4CXIx7tPeHmciJtHP+4RRAm6ChWAMkYzTkg8w0SwNTUI0y2fsgNFdMdFIPTfYbKQRVr1sO6Dgp1orzXcPz65srvvYsJPAGWvGnTDMM/QKz6uiJy0J6lwAAAABJRU5ErkJggg=="
                    alt="微信支付"
                  >
                </div>
                <div class="text">微信支付(在线支付即时到账)</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="对公转账" name="toPublic">
            <div class="pay-method">
              <div class="to-public">
                <div class="img">
                  <img
                    src="data:image/png;base64,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"
                  >
                </div>
                <div class="text">
                  <div>公司名称：<span>安徽节点信息科技有限公司</span></div>
                  <div>对公账户：<span>5489 0188 0000 29408</span></div>
                  <div>开户银行：<span>中国光大银行股份有限公司滁州分行</span></div>
                  <div>
                    <el-alert type="warning" show-icon :closable="false">
                      <span slot="title" class="font-color-danger">转帐时请注明站点名称；转帐后请联系站点专属辅导员(对公支付1小时内到帐)</span>
                    </el-alert>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="handle-money">应付金额：<font>{{ currentMoney }}</font></span>
        <el-button v-if="payMethod === 'weixin'" :disabled="currentId === 0" type="success" @click="pay">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 确认支付页面，并且加入二维码 -->
    <el-dialog :visible.sync="qcodeSwitch" width="500px" :before-close="handleClose" append-to-body>
      <template slot="title">
        <span class="dialog-title">打开手机微信，扫一扫完成支付</span>
      </template>
      <div class="order-info">
        <div><span>商品订单：</span>{{ orderInfo.orderNo }}</div>
        <div><span>支付金额：</span>
          <font>￥{{ orderInfo.amount }}</font>
        </div>
      </div>
      <div v-if="!orderStatusSwitch" class="order-img">
        <div class="qcode">
          <qrcode class="qrcode" :value="orderInfo.codeUrl" :margin="0" :quality="1" />
          <div>打开手机微信，扫一扫完成支付</div>
        </div>
        <div class="sample">
          <img src="https://assets.myjiedian.com/admin/develop/img/scan.00a2d8bd.png" alt="">
        </div>
      </div>
      <div v-else class="order-success">
        <div class="success-info">
          <success v-if="orderStatus==='支付成功'" class="icon-park" theme="multi-color" size="40" :fill="['#7ed321' ,'#ffffff' ,'#7ed321' ,'#7ed321']" />
          <close-one v-else-if="orderStatus==='支付失败'" class="icon-park" theme="multi-color" size="40" :fill="['#f56c6c' ,'#ffffff' ,'#f56c6c' ,'#ffffff']" />
          <close-one v-else-if="orderStatus==='已关闭'" class="icon-park" theme="multi-color" size="40" :fill="['#f56c6c' ,'#ffffff' ,'#f56c6c' ,'#ffffff']" />
          <forbid v-else class="icon-park" theme="multi-color" size="40" :fill="['#f56c6c' ,'#ffffff' ,'#f56c6c' ,'#ffffff']" />
          <span>{{ orderStatus }}</span>
        </div>
        <div class="success-help">如有疑问请联系群内客服或者电话联系：15212181071</div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Qrcode from 'vue-qrcode'
import { getMarketPayQrCode, getMarketPayList } from '../../api/pay'
import { getOrderInfo } from '../../api/order'
import { Success, CloseOne, Forbid } from '@icon-park/vue'

export default {
  name: 'Recharge',
  // 组件初始化渲染
  components: {
    Qrcode,
    Success,
    CloseOne,
    Forbid
  },
  // 父组件传值
  props: {
    surplus: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: '充值'
    }
  },
  // 数据
  data() {
    return {
      loading: false,
      // 充值金额列表
      rechargeItem: [],
      // 选择充值项目
      currentId: 0,
      currentMoney: '-',
      // 默认标签页
      payMethod: 'weixin',

      // 开启二维码确认弹窗
      qcodeSwitch: false,

      // 订单数据
      orderInfo: {},

      // 订单支付是否成功
      orderStatusSwitch: false,
      orderStatus: 0,

      // 递归次数
      recursionCount: 0
    }
  },
  // 计算属性
  computed: {
    ...mapGetters(['jurisdiction', 'searchParams', 'user'])
  },
  // 监听属性
  watch: {},
  // 创建实例钩子函数
  created() {},
  // 挂载实例钩子函数
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown) // 开启监听键盘按下事件
    this.init()
  },
  // 销毁实例前钩子函数
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown) // 移除监听键盘按下事件
  },
  // 销毁实例钩子函数
  destroyed() {},
  // 时间处理器
  methods: {
    // 监听键盘按键事件
    handleKeyDown(e) {
      let key = null
      if (window.event === undefined) {
        key = e.keyCode
      } else {
        key = window.event.keyCode
      }
      if (key === 13) {
        // 这里处理回车键的操作
      }
    },
    // 初始化
    init() {
      // 判断是否有权限，没有权限返回登录页面
      if (this.searchParams && this.searchParams.company) {
        this.searchForm = this.searchParams.company.searchForm
        this.$store.dispatch({
          type: 'login/setSearchParams',
          searchParams: null
        })
      }
      // 处理初始化数据的操作
      this.getPayList()
    },

    /**
     * 获取支付套餐
     */
    getPayList() {
      this.loading = true
      getMarketPayList({ type: this.type })
        .then((res) => {
          // 成功逻辑
          if (res.code === 200) {
            this.rechargeItem = res.data || []
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err, 'err getPayList')
        })
    },

    // 点击充值选项
    radioChange(val) {
      this.rechargeItem.forEach((el) => {
        if (el.id === val) {
          this.currentMoney = el.price + '元'
        }
      })
    },

    // 支付操作
    pay() {
      // 初始化操作
      this.orderStatus = 0
      this.orderStatusSwitch = false
      this.recursionCount = 0

      // 判断是否勾选套餐
      if (!this.currentId) {
        this.$message({
          type: 'error',
          message: '请选择需要充值的短信套餐'
        })
        return
      }

      // 获取链接封装成微信支付二维码
      getMarketPayQrCode(this.currentId)
        .then((res) => {
          // 成功逻辑
          if (res.code === 200) {
            this.orderInfo = res.data
            this.qcodeSwitch = true
            this.getOrderInfo()
          }
        })
        .catch((err) => {
          this.loading = false
          console.log(err, 'err getPayQrCode')
        })
    },

    // 关闭二维吗弹窗
    handleClose() {
      if (!this.orderStatusSwitch) {
        this.$confirm('是否放弃本次支付, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.qcodeSwitch = false
          })
          .catch(() => {})
      } else {
        this.qcodeSwitch = false
      }
    },

    // 轮训查询订单支付信息
    getOrderInfo() {
      if (!this.orderInfo.orderNo) {
        return false
      }

      this.recursionCount++

      // 访问轮训查询订单信息
      getOrderInfo(this.orderInfo.orderNo)
        .then((res) => {
          // 成功逻辑
          if (res.code === 200) {
            if (res.data === 1) {
              // 递归延迟1.5秒访问支付接口
              if (this.recursionCount < 20) {
                setTimeout(() => {
                  if (this.qcodeSwitch && res.data === 1) {
                    this.getOrderInfo()
                  }
                }, 1500)
                return
              } else {
                this.$message({
                  type: 'warning',
                  message: '你的网络环境有问题，请刷新查看是否充值成功'
                })
                // 重置递归次数
                this.recursionCount = 0
                return
              }
            }

            this.orderStatusSwitch = true

            // 返回文字样式
            if (res.data === 2) {
              this.orderStatus = '支付成功'
            } else if (res.data === 3) {
              this.orderStatus = '支付失败'
            } else if (res.data === 4) {
              this.orderStatus = '已关闭'
            } else {
              this.orderStatus = '未知'
            }

            // 重置递归次数
            this.recursionCount = 0
          }
        })
        .catch((err) => {
          console.log(err, 'err getOrderInfo')
        })
    },

    // 关闭短信充值窗口
    handleSmsClose() {
      // 返回给父组件通知刷新短信数据
      this.$emit('func')
    }
  }
}
</script>
<style lang="scss">
.recharge .el-dialog__body {
  padding: unset !important;
  .el-radio__label {
    font-size: 20px;
  }
}
.pay .el-tabs--border-card {
  box-shadow: unset;
}
</style>
<style lang="scss" scoped>
.dialog-title {
  font-size: 14px;
  font-weight: 500;
}
.recharge {
  background-color: #ebeef5;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 5px;
  .recharge-item {
    width: 50%;
    padding: 35px 20px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    border: 1px solid #ebeef5;
    .number {
      font-weight: 500;
      color: #ff6000;
    }
    font {
      color: #999;
    }
  }
  .choose {
    background-color: #f1f8ff;
  }
  .pick-label {
    color: #0078ff;
  }
}

.pay-method {
  padding: 30px;
  .weixin {
    border: 1px solid #f9e3c4;
    background-color: #fff8ee;
    display: flex;
    align-items: center;
    height: 50px;
    width: 265px;
    .img {
      padding: 0 10px;
      > img {
        width: 28px;
        height: 28px;
      }
    }
    .text {
      line-height: 28px;
      font-size: 16px;
      color: #333;
    }
  }
  .to-public {
    display: flex;
    .img {
      padding: 0 20px;
    }
    .text {
      color: #999;
      > div {
        margin: 10px 0;
        > span {
          color: #333;
        }
      }
    }
  }
}

.handle-money {
  margin-right: 20px;
  > font {
    color: #f56c6c;
    font-weight: 500;
  }
}

.order-info {
  height: 70px;
  color: #333;
  border-bottom: 1px solid #eee;
  > div {
    margin: 10px 0;
    span {
      font-weight: 500;
    }
    font {
      color: #f56c6c;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
.order-img {
  display: flex;
  padding: 20px;
  .qcode {
    > img {
      width: 200px;
      height: 200px;
    }
    > div {
      color: #fff;
      background-color: #67c23a;
      height: 25px;
      line-height: 25px;
      width: 200px;
      font-size: 12px;
      text-align: center;
      margin-top: -3px;
      font-weight: 500;
    }
  }
  .sample {
    padding-left: 20px;
    > img {
      width: 180px;
    }
  }
}

// 支付成功样式
.order-success {
  font-size: 20px;
  font-weight: 500;
  padding: 20px;
  .success-info {
    > span {
      margin-left: 5px;
    }
  }
}
.success-help {
  margin-top: 5px;
  font-size: 12px;
  color: #909399;
}
</style>
